export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-plane-9e718109e77db818bf3cc547c9571dfc.png";